// extracted by mini-css-extract-plugin
module.exports = {"root":"Column_root__nPsZM","fullWidth":"Column_fullWidth__5Hoou"};